(function () {
    var swiperInitialized = false;
  
    function initSwiper() {
      if (swiperInitialized) return;
  
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css";
      document.head.appendChild(link);
  
      var script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js";
      script.onload = function () {
        const $currentSwiper = document.querySelector(".mySwiper");
        if (!$currentSwiper) return;
  
        const enableSwiperDesktop =
          $currentSwiper.dataset.enableSwiperDesktop === "true";
        const enableSwiperMobile =
          $currentSwiper.dataset.enableSwiperMobile === "true";
        const totalSlides =
          $currentSwiper.querySelectorAll(".swiper-slide").length;
        const desktopRotationSpeed =
          parseInt($currentSwiper.dataset.desktopRotationSpeed) || 5000;
        const mobileRotationSpeed =
          parseInt($currentSwiper.dataset.mobileRotationSpeed) || 5000;
        const transitionSmoothness =
          parseInt($currentSwiper.dataset.transitionSmoothness) || 750;
  
        function initSlider(
          event,
          enableSwiperDesktop,
          enableSwiperMobile,
          totalSlides
        ) {
          if (event.matches && enableSwiperDesktop) {
            if (window.swiperFull) {
              window.swiperFull.destroy();
            }
  
            window.swiperFull = new Swiper(".mySwiper", {
              slidesPerView: "auto",
              spaceBetween: 20,
              loop: totalSlides > 5,
              loopAdditionalSlides: 5,
              speed:
                totalSlides > 5 ? desktopRotationSpeed : transitionSmoothness,
              autoplay: totalSlides > 5 ? { delay: 0 } : false,
              allowTouchMove: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          } else if (enableSwiperMobile) {
            if (window.swiperMobile) {
              window.swiperMobile.destroy();
            }
  
            let autoplayTimeout;
  
            window.swiperMobile = new Swiper(".mySwiper", {
              slidesPerView: 1.3,
              spaceBetween: 15,
              loop: true,
              speed: mobileRotationSpeed,
              autoplay:
                totalSlides > 1
                  ? {
                      delay: mobileRotationSpeed,
                      disableOnInteraction: false,
                    }
                  : false,
              allowTouchMove: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              on: {
                touchStart: function (swiper) {
                  swiper.autoplay.stop();
                  clearTimeout(autoplayTimeout);
                },
                touchEnd: function (swiper) {
                  autoplayTimeout = setTimeout(() => {
                    swiper.autoplay.start();
                  }, 3000);
                },
              },
            });
          }
        }
  
        const mmObj = window.matchMedia("(min-width: 768px)");
        initSlider(mmObj, enableSwiperDesktop, enableSwiperMobile, totalSlides);
        mmObj.addEventListener("change", function () {
          initSlider(mmObj, enableSwiperDesktop, enableSwiperMobile, totalSlides);
        });
      };
  
      document.body.appendChild(script);
      swiperInitialized = true;
    }
    initSwiper();
  })();